<div class="pd-tb">
    <div class="container">
        <div class="row">
            <div class="col-lg-10 col-sm-12 col-md-12  account-settings ">

                <div class="topHeader">
                    <h2 class="pageTitle">Account Settings <a class="red" (click)="deleteAccount($event)"> Delete Account</a></h2>
                </div>
                <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
                    <div class="profileInfo mb-5">
                        <div class="profile-upload ">
                            <div class="proEdit">
                                <input type="file" id="imageUpload" accept=".png, .jpg, .jpeg" #myInput (change)="upload($event)">
                                <label id="imageUpload"><i class="ic_profile_edit"><img src="assets/images/ic_profile_edit.svg"></i></label>
                            </div>
                            <div class="avatar-preview">
                                <!-- <div id="imagePreview">
                                    <img  [src]="dummyImage || '../../../assets/images/profile-img.jpg'" alt="profile"/>
                                </div> -->
                                <div id="imagePreview">
                                    <img [src]="imageUpload != null || imageUpload == '' ? globalUrl + imageUpload : '../../../assets/images/profile-img.jpg'" alt="profile">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-lg-6  col-sm-12">
                            <div class="form-group">
                                <label>Full Name</label>
                                <div *ngIf="!editMode">
                                    <a href="javascript:void(0);" (click)="editName()"><img src="../../../assets/images/ic_edit.svg" alt="edit" class="editbtn2 ht"></a>
                                    <input type="text" class="form-control firstlCaptial" placeholder="Name" formControlName="name" readonly>
                                </div>
                                <div *ngIf="editMode"> 
                                    <input type="text" class="form-control cap" placeholder="Name" formControlName="name">
                                </div>

                            </div>
                            <div class="padding-top">
                                <a href="javascript:void(0);" (click)="toRedirect()" class="orange">Change Password</a>
                            </div>

                        </div>

                        <div class="col-md-6 col-lg-6  col-sm-12">
                            <div class="form-group">
                                <label>Email</label>

                                <input type="email" class="form-control" placeholder="example123@gmail.com"  formControlName="email">
                            </div>
                        </div>

                        <div class="form-group col-md-12 co-sm-12 col-lg-12">
                            <input type="submit" value="Save" class="commonBtn width50 mt-2"/>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>
 
<div class="modal cropperModal" role="dialog" *ngIf="show">
    <div class="modal-dialog  cropperBox" role="document">
        <div class="modal-content">
            <div class="modal-header border-bottom-0 ">
                <div class="form-title">
                    <h2 class="mainTitle text-center">Image Cropper</h2>
                </div>
                <!-- <button type="button cursorHandPoint" class="close " (click)="close()" data-dismiss="modal " aria-label="Close ">&times;</button> -->
            </div>
            <div class="modal-body">
                <app-common-upload [objectProperty]="objectProp" (valueChange)='catchFile($event)'
                    (changeDetected)="onChangeDetected($event)"></app-common-upload>
               
            </div>
        </div>
    </div>
</div>